export class CloudStaticDocStorage {
  name = 'cloud-static';
  constructor(private readonly workspaceId: string) { }

  async pull(
    docId: string
  ): Promise<{ data: Uint8Array; state?: Uint8Array | undefined } | null> {
    const { getPiqueCloudBaseUrl } = await import('../../../cloud/services/fetch');
    const { addTauriAuthHeaders } = await import('../../../cloud/utils/tauri-auth');

    const url = `${getPiqueCloudBaseUrl()}/api/workspaces/${this.workspaceId}/docs/${docId}`;
    const headers = await addTauriAuthHeaders({});

    const response = await fetch(
      url,
      {
        priority: 'high',
        headers,
      } as any
    );
    if (response.ok) {
      const arrayBuffer = await response.arrayBuffer();

      return { data: new Uint8Array(arrayBuffer) };
    }

    return null;
  }
}
